<template>
    <div class="w-100 h-100">
        <div class="row">
            <div class="col-md" v-for="(button, index) in options">
                <button
                    type="button"
                    class="btn"
                    :class="{ 'btn-outline-primary' : period != index , 'btn-primary' : period == index}"
                    style="width:100%"
                    @click="period = index"
                >{{ button.title }}</button>
            </div>
            <!-- Custom Start -->
            <div class="col-md">
                <button
                    type="button"
                    class="btn"
                    :class="{ 'btn-outline-primary' : period != 100 , 'btn-primary' : period == 100}"
                    style="width:100%"
                    @click="modal.customDate = true"
                >Custom</button>
            </div>
            <!-- Custom End -->
        </div>

        <!-- Modal Start -->
        <custom-period
            v-if="modal.customDate"
            :currentSelected="form"
            @closeModal="modal.customDate = false"
            @setCustomDate="setCustomDate"
        ></custom-period>
        <!-- Modal End -->

    </div>
</template>

<script>
    import moment from 'moment'

    import customPeriod from './customPeriod'

    export default {
        data () {
            return {
                modal : {
                    customDate : false,
                },
                moment : moment,
                period : 0,
                options : [
                    {
                        title : "MTD",
                        start : "this.moment().startOf('month').format('YYYY-MM-DD 00:00:00')",
                        end : "this.moment().format('YYYY-MM-DD 23:59:59')",
                        period : 1
                    },
                    {
                        title : "Last Month",
                        start : "this.moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD 00:00:00')",
                        end : "this.moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD 23:59:59')",
                        period : 2
                    },
                    {
                        title : "This Year",
                        start : "this.moment().startOf('year').format('YYYY-MM-DD 00:00:00')",
                        end : "this.moment().format('YYYY-MM-DD 23:59:59')",
                        period : 3
                    },
                    {
                        title : "Last Year",
                        start : "this.moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD 00:00:00')",
                        end : "this.moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD 23:59:59')",
                        period : 4
                    }
                ],
                form : {
                    start : moment().startOf('month').format('YYYY-MM-DD 00:00:00'),
                    end : moment().format('YYYY-MM-DD 23:59:59')
                }
            }
        },
        props : ['periodFilter'],
        components : {
            customPeriod,
        },
        mounted () {
            // this.$emit('newDateRange', this.form);
        },
        watch : {
            period () {
                if (this.period == 100) return;

                this.form.start = eval(this.options[this.period].start);
                this.form.end = eval(this.options[this.period].end);
                this.form.period = eval(this.options[this.period].period)

                this.$emit('newDateRange', this.form);
            }
        },
        methods : {
            setCustomDate (dates) {
                this.form.start = moment(dates.start).format('YYYY-MM-DD 00:00:00');
                this.form.end = moment(dates.end).format('YYYY-MM-DD 23:59:59');
                this.form.period = 5;

                this.period = 100;
                this.$emit('newDateRange', this.form);
                
                this.modal.customDate = false;
            },
        }
    }
</script>

<style scoped>

</style>